import { useState, useEffect } from 'react';

interface FeedbackBannerProps {
  articleTitle: string;
  articleUrl: string;
}

export default function FeedbackBanner({ articleTitle, articleUrl }: FeedbackBannerProps) {
  const [isVisible, setIsVisible] = useState(false);
  const [selectedRating, setSelectedRating] = useState<number | null>(null);
  const [hoveredRating, setHoveredRating] = useState<number | null>(null);

  useEffect(() => {
    // Mostra o banner após 15 segundos
    const showTimer = setTimeout(() => {
      setIsVisible(true);
    }, 15000);

    return () => clearTimeout(showTimer);
  }, []);

  useEffect(() => {
    if (isVisible) {
      // Esconde o banner após 5 segundos
      const hideTimer = setTimeout(() => {
        setIsVisible(false);
      }, 5000);

      return () => clearTimeout(hideTimer);
    }
  }, [isVisible]);

  const handleRatingClick = async (rating: number) => {
    setSelectedRating(rating);

    // Envia o feedback por email
    try {
      const emailData = {
        to: 'contato@ativonews.com.br',
        subject: `Feedback do Artigo: ${articleTitle}`,
        rating: rating,
        articleTitle: articleTitle,
        articleUrl: articleUrl,
        timestamp: new Date().toISOString()
      };

      // Aqui você pode integrar com um serviço de email
      // Por enquanto, vamos apenas fazer um log
      console.log('Feedback enviado:', emailData);

      // Esconde o banner após 1 segundo da avaliação
      setTimeout(() => {
        setIsVisible(false);
      }, 1000);
    } catch (error) {
      console.error('Erro ao enviar feedback:', error);
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 animate-slide-up">
      <div className="bg-white rounded-xl shadow-2xl border-2 border-[#059669] p-6 max-w-sm">
        <div className="flex items-start gap-3 mb-4">
          <div className="w-10 h-10 bg-[#059669] text-white rounded-lg flex items-center justify-center flex-shrink-0">
            <i className="ri-feedback-line text-xl"></i>
          </div>
          <div>
            <h3 className="text-lg font-bold text-[#0F172A] mb-1">
              Está gostando do conteúdo?
            </h3>
            <p className="text-sm text-[#64748B]">
              Sua opinião é muito importante para nós!
            </p>
          </div>
        </div>

        <div className="flex items-center justify-center gap-2 mb-3">
          {[1, 2, 3, 4, 5].map((star) => (
            <button
              key={star}
              onClick={() => handleRatingClick(star)}
              onMouseEnter={() => setHoveredRating(star)}
              onMouseLeave={() => setHoveredRating(null)}
              className="transition-transform hover:scale-110 focus:outline-none"
              aria-label={`Avaliar com ${star} estrela${star > 1 ? 's' : ''}`}
            >
              <i
                className={`text-3xl ${
                  (hoveredRating !== null && star <= hoveredRating) ||
                  (hoveredRating === null && selectedRating !== null && star <= selectedRating)
                    ? 'ri-star-fill text-[#F59E0B]'
                    : 'ri-star-line text-gray-300'
                }`}
              ></i>
            </button>
          ))}
        </div>

        {selectedRating && (
          <div className="text-center">
            <p className="text-sm font-semibold text-[#059669] flex items-center justify-center gap-2">
              <i className="ri-check-line"></i>
              Obrigado pelo seu feedback!
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
